export enum ReportStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    RESOLVED = 'RESOLVED',
    CANCELLED = 'CANCELLED',
}

// ========================================
// OCURRENCE INTERFACES
// ========================================

export * from './occurrence.interface';

// ========================================
// OCCURRENCE DISPATCH INTERFACES
// ========================================

export * from './occurrence-dispatch.interface';

// ========================================
// DOORMAN CHECKLIST INTERFACES
// ========================================

export * from './doorman-checklist.interface';

// ========================================
// VEHICLE CHECKLIST INTERFACES
// ========================================

export * from './vehicle-checklist.interface';

// ========================================
// MOTORCYCLE CHECKLIST INTERFACES
// ========================================

export * from './motorcycle-checklist.interface';
